const NO_SHOUTCAST_REGEX = /(tunein|rfcm).*streamguys|tunein.com|mediatailor/;
const SHOUTCAST_TIMEOUT = 25000;
function applyShoutcastUrlFallback(url = '') {
    const { protocol, pathname, search, host } = new URL(url);
    const shoutcastHack = pathname.endsWith('/') ? ';' : '/;';
    if (pathname.endsWith(shoutcastHack)) {
        return url;
    }
    return `${protocol}//${host}${pathname}${shoutcastHack}${search}`;
}
export function injectShoutcastStreams(streams, nextStream) {
    const { isPrerollStream, isBoostStream, isSubscriptionRequiredStream, url } = nextStream;
    if (isPrerollStream ||
        isBoostStream ||
        isSubscriptionRequiredStream ||
        url.includes('/;') ||
        NO_SHOUTCAST_REGEX.test(url)) {
        return [...streams, nextStream];
    }
    const shoutCastStream = {
        ...nextStream,
        isShoutcastUrl: true,
        timeout: SHOUTCAST_TIMEOUT,
        url: applyShoutcastUrlFallback(url),
    };
    return [...streams, nextStream, shoutCastStream];
}
